/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Modal, Button } from '@atoms';

import { Form } from '@organisms';

const RelatedCompetitionModal = ({
  okText,
  cancelText = 'Cancel',
  hide,
  onSubmit,
  onCancel = hide,
  children,
  ...props
}) => {
  const [confirmLoading, setConfirmLoading] = React.useState(false);
  const [form] = Form.useForm();

  const handleOk = async () => {
    try {
      setConfirmLoading(true);
      const data = await form.validateFields();
      await onSubmit(data);
      form.resetFields();
      setConfirmLoading(false);
      hide();
    } catch (e) {
      setConfirmLoading(false);
    }
  };

  const footer = (
    <>
      <Button key="submit" type="customBlue" loading={confirmLoading} onClick={handleOk}>
        {okText}
      </Button>

      <Button key="back" onClick={onCancel} disabled={confirmLoading}>
        {cancelText}
      </Button>
    </>
  );

  return (
    <Modal footerDivider={false} footer={footer} {...props}>
      <Form form={form} layout="vertical" name="form_in_modal">
        {children}
      </Form>
    </Modal>
  );
};

export default RelatedCompetitionModal;
